import { 
  Leaf, 
  Egg, 
  Flame, 
  Scale, 
  Shield, 
  HeartPulse,
  Wheat,
  Beef
} from 'lucide-react';
import { cn } from '../../lib/utils';

const iconMap = {
  'leaf': Leaf,
  'egg': Egg,
  'flame': Flame,
  'scale': Scale,
  'cow': Beef,
  'shield': Shield,
  'wheat-off': Wheat,
  'heart-pulse': HeartPulse,
};

export const DietCard = ({ 
  diet, 
  selected = false, 
  onSelect,
  disabled = false 
}) => {
  const Icon = iconMap[diet.icon] || Leaf;

  return (
    <button
      type="button"
      onClick={() => !disabled && onSelect?.(diet.id)}
      disabled={disabled}
      className={cn(
        "relative p-6 rounded-2xl border-2 text-left transition-all duration-300",
        "hover:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        selected 
          ? "border-primary bg-primary/5 ring-2 ring-primary/20" 
          : "border-border bg-card hover:border-primary/50",
        disabled && "opacity-50 cursor-not-allowed"
      )}
      aria-pressed={selected}
      data-testid={`diet-card-${diet.id}`}
    >
      <div className="flex items-start gap-4">
        <div className={cn(
          "p-3 rounded-xl transition-colors",
          selected ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"
        )}>
          <Icon className="h-6 w-6" aria-hidden="true" />
        </div>
        <div className="flex-1">
          <h3 className="font-heading text-lg font-semibold text-card-foreground">
            {diet.name}
          </h3>
          <p className="mt-1 text-sm text-muted-foreground">
            {diet.description}
          </p>
        </div>
      </div>
      
      {selected && (
        <div className="absolute top-3 right-3 w-3 h-3 rounded-full bg-primary" aria-hidden="true" />
      )}
    </button>
  );
};
